import React from 'react'

const SectionHead = ({ title }) => {
    return (
        <div className='w-full my-6'>
            <h3 className='text-lg opacity-80 font-semibold'>{title}</h3>
        </div>
    )
}

export default SectionHead